import styled from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: ${props => (props.forward ? 'auto' : 'none')};
  z-index: ${props => (props.forward ? '1000' : '-1000')};
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: opacity 0.3s ease-in;
  background-color: black;
  opacity: ${props => (props.active ? '0.3' : '0')};
`;

export const StyledSlidingContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: ${props => props.theme.colors.get(props.bgColor)};
  position: fixed;
  top: 0;
  ${props => `${props.alignment}: -${props.maxWidth}px`};
  max-width: ${props => props.maxWidth}px;
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  padding: ${props => props.theme.spacing(5)};
  @media ${props => props.theme.laptop} {
    padding: 36px;
  }
  transition: transform ease-in-out 250ms;
  transform: ${props =>
    // props.active ? `translateX(-480px)` : 'translateX(0)'};
    props.active
      ? `translateX(${
          props.alignment === 'left'
            ? props.maxWidth + 'px'
            : '-' + props.maxWidth + 'px'
        })`
      : 'translateX(0)'};

  ${props => props.theme.scrollBar}
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: ${props => props.theme.spacing(18)};
`;

export const CloseIcon = styled.button`
  background: none;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  &:focus {
    outline: 1px solid ${props => props.theme.colors.text.primary};
  }
`;

export const OllieLogo = styled.div`
  margin: auto;
  padding-right: ${props => props.theme.spacing(5)};
`;

export const LogoImgContainer = styled.div`
  height: 100%;
  max-height: 24px;
`;
